import { pages, pagesDirection, pagesMultiJump } from "./stores";
import { get } from "svelte/store";
import { eagerLoadingRightImages } from "./utils";

let thisPages;
let thisCurrentUrl;

export function updatePages(currentUrl, forceForward) {
	const forceBackwardsPages = [
		'/'
	];
	pages.update((_pages) => {
		thisPages = _pages;
		thisCurrentUrl = currentUrl;
		if(forceForward && !forceBackwardsPages.includes(thisCurrentUrl)) {
			return forwardToUnknownPage() || [];
		}
		return backwardsToKnownPage() || forwardToUnknownPage() || [];
	});
}

function forwardToUnknownPage() {
	pagesDirection.set('rtl');
	
	// if Menu is visible replace the latest page
	// otherwise it would look like driving twice
	return [...thisPages, {id: thisPages.length, path: thisCurrentUrl, hash: window.location.hash}];
}

export function backwardsToKnownPage() {
	let indexKnownPage = null;
	for (let i = 0; i < thisPages.length; i++) {
		if (thisPages[i].path === thisCurrentUrl) {
			indexKnownPage = i;
		}
	}
	if (indexKnownPage === null) {
		return false;
	}
	
	// page already visited:
	pagesDirection.set('ltr');
	setTimeout(() => {
		eagerLoadingRightImages();
		window.history.replaceState('removeAnchor', '', window.location.pathname);
	}, 200);
	return thisPages.slice(0, indexKnownPage + 1);
}

export function navigateToLastPage() {
	window.history.back();
	// to keep the array clean:
	pages.update(_pages => {
		return _pages.slice(0, -1);
	});
}

export function calculatePageAnimation(divName, out) {
	const pageDir = get(pagesDirection);
	const inOut = out ? 'out' : 'in';
	const multiJump = get(pagesMultiJump);
	
	const animationCase = [pageDir, inOut, multiJump].join('');
	
	function like(animationSwitch) {
		return animationSwitch.join('');
	}
	
	let rightStart = 0;
	let rightEnd = 0;
	
	if (divName === 'now') {
		switch (animationCase) {
			case like(['rtl', 'in', false]):
			case like(['rtl', 'in', true]):
				rightStart = -100;
				rightEnd = 0;
				break;
			case like(['rtl', 'out', false]):
			case like(['rtl', 'out', true]):
				rightStart = 0;
				rightEnd = 100;
				break;
			case like(['ltr', 'in', false]):
			case like(['ltr', 'in', true]):
				rightStart = 100;
				rightEnd = 0;
				break;
			case like(['ltr', 'out', false]):
			case like(['ltr', 'out', true]):
				rightStart = 0;
				rightEnd = -100;
				break;
		}
	}
	
	if (divName === 'prev') {
		switch (animationCase) {
			case like(['rtl', 'in', false]):
			case like(['rtl', 'in', true]):
				rightStart = -100;
				rightEnd = 0;
				break;
			case like(['rtl', 'out', false]):
			case like(['rtl', 'out', true]):
				rightStart = 0;
				rightEnd = 100;
				break;
			case like(['ltr', 'in', false]):
			case like(['ltr', 'in', true]):
				rightStart = 100;
				rightEnd = 0;
				break;
			case like(['ltr', 'out', false]):
			case like(['ltr', 'out', true]):
				rightStart = 0;
				rightEnd = -100;
				break;
		}
	}
	
	if (divName === 'off') {
		switch (animationCase) {
			case like(['rtl', 'in', false]):
			case like(['rtl', 'in', true]):
				rightStart = -100;
				rightEnd = 0;
				break;
			case like(['rtl', 'out', false]):
			case like(['rtl', 'out', true]):
			case like(['ltr', 'in', false]):
			case like(['ltr', 'in', true]):
				rightStart = 0;
				rightEnd = 0;
				break;
			case like(['ltr', 'out', false]):
				rightStart = 0;
				rightEnd = -100;
				break;
			case like(['ltr', 'out', true]):
				rightStart = 0;
				rightEnd = -2 * 100;
				break;
		}
	}
	
	return {rightStart: rightStart, rightEnd: rightEnd};
}
